// extracted by mini-css-extract-plugin
module.exports = {"hotspot":"Hotspot_hotspot__29hoh","hotspotImg":"Hotspot_hotspotImg__1Evc1","hotspoterror":"Hotspot_hotspoterror__2NaWi","hotspotDisplayName":"Hotspot_hotspotDisplayName__3xtYv"};